<template>
  <div>
    <!--风险提示-->
    <el-dialog class="dialog-single-three" :visible.sync="dialogVisable" :show-close="false" :close-on-click-modal="false">
      <div class="dialog-single-three-p">风险测评</div>
      <p class="riskText">{{msg}}</p>
      <div class="margin-t20">
        <el-button v-if="evaluation == '开始测评'" type="back" style="width:154px;" @click="$router.push({name:'myAssets'});dialogVisable = false;">暂不</el-button>
        <el-button v-if="evaluation == '重新测评'" type="back" style="width:154px;" @click="evaluationClick">{{riskTypeText}}</el-button>
        <el-button type="normal" style="width:154px;" @click="reevaluation">{{evaluation}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
export default {
  name: "RiskTips",
  data () {
    return {
      dialogVisable: false,//风险提示
      msg: '',
      evaluation: '',
      riskTypeText: '',
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    // 全局数据
    getData () {
      this.$http.post(this.$apiPath.sessionId, {
        sessionId: this.$commonJs.getCookie('sessionid'),
      }).then(res => {
        if (res.status !== 200 && res.data.code !== '200') return
        let riskInfo = res.data.data.risklevelInfo[0]
        const risklevel = this.$commonJs.getCookie('u_risk')
        if (riskInfo.evaluateflag == "N") {//没有测试过,//Y为已经测试，N为没有测试,risklevel
          if (risklevel === '0') {
            this.msg = '尊敬的投资者，您还没有进行风险承受能力测评，请先进行测评吧。'
            this.evaluation = '开始测评'
            this.dialogVisable = true
          } else {
            this.dialogVisable = false
          }
        } else if (riskInfo.signdate < '20170602' || riskInfo.expiredflag == "Y") {
          if (window.sessionStorage.getItem('keep') == "true") {
            this.dialogVisable = false
          } else {
            this.msg = '尊敬的投资者，您距离上次风险测评已经超过6个月，若您的风险偏好相关信息发生变更，请您重新测评。';
            this.evaluation = '重新测评'
            this.dialogVisable = true
            this.riskTypeText = '确认保持“' + this.$commonJs.getPersonalLevel(risklevel).substr(2, 3) + '”'
          }
        } else {// 有风险等级
          this.dialogVisable = false
        }
        this.$emit('func', !this.dialogVisable)
      }).catch(error => { })
    },
    reevaluation () {
      this.$router.push({ name: 'accountManagement', params: { active: '3', risk: true } })
    },
    // 保持风险登记
    evaluationClick () {
      this.$http.post(this.$apiPath.modification, {
        custno: this.$commonJs.getCookie('u_custno1')
      }).then(res => {
        if (res.data.code == "200") {
          this.$message.success(res.data.data.flag)
          this.dialogVisable = false
          window.sessionStorage.setItem('keep', true)
        }
      }).catch(err => { })
    },
  }

}
</script>

<style lang="less" scoped>
.riskText {
  font-size: 16px;
  margin-top: 20px;
}
</style>
